import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import colors from '../../../../styling/colors';
import HandOffLink from '../../../../utils/urls/HandOffLink';
import Facebook from '../../../../assets/svg/Facebook';
import Google from '../../../../assets/svg/Google';

const GoogleSVG = styled(Google)`
  position: absolute;
  left: 0;
  margin: 0.75rem 1rem;
  top: -2px;
`;

const FacebookSVG = styled(Facebook)`
  position: absolute;
  left: 0;
  margin: 0.75rem 1rem;
  top: 0;
`;

const SocialButtonStyles = css`
  border: 2px solid;
  display: block;
  position: relative;
  font-size: 0.75rem;
  font-weight: bold;
  letter-spacing: 0.125rem;
  line-height: 3rem;
  margin-bottom: 1rem;
  height: 3rem;
  position: relative;
  text-transform: uppercase;
  width: 100%;
`;

const FacebookButtonLink = styled(HandOffLink)`
  ${SocialButtonStyles} color: ${colors('white')};
  background-color: ${colors('facebook')};
  border-color: ${colors('facebook')};
  margin-bottom: 0.75rem;

  &:hover {
    background-color: ${colors('facebook', 'darken')};
    border-color: ${colors('facebook', 'darken')};
  }
`;

const GoogleButtonLink = styled(HandOffLink)`
  ${SocialButtonStyles} color: ${colors('black')};
  background-color: ${colors('white')};
  border-color: ${colors('alto')};
  margin-bottom: 0.75rem;

  &:hover {
    background-color: ${colors('white', 'darken')};
  }
`;

export default class SocialButtons extends Component {
  static propTypes = {
    redirectUrl: PropTypes.string,
    type: PropTypes.oneOf(['login', 'signup']),
  };

  render() {
    const { children, redirectUrl, type } = this.props;

    let redirectQueryString = '';

    if (redirectUrl) {
      redirectQueryString = `?origin=${encodeURIComponent(redirectUrl)}`;
    }

    return (
      <div>
        <GoogleButtonLink
          identifier={'google-' + type}
          href={`/auth/google_oauth2${redirectQueryString}`}
        >
          <GoogleSVG strokeColor="white" />
          {children} with Google
        </GoogleButtonLink>
        <FacebookButtonLink
          identifier={'facebook-' + type}
          href={`/auth/facebook${redirectQueryString}`}
        >
          <FacebookSVG height="20px" strokeColor="white" />
          {children} with Facebook
        </FacebookButtonLink>
      </div>
    );
  }
}
